(() => {
  const ROOT = '[data-af-content-selector]';

  class AFContentSelector {
    constructor(root) {
      if (!root || root.dataset.afContentSelectorReady === 'true') return;

      this.root = root;
      this.tabs = Array.from(root.querySelectorAll('[data-af-content-selector-tab]'));
      this.panels = Array.from(root.querySelectorAll('[data-af-content-selector-panel]'));

      if (!this.tabs.length || this.tabs.length !== this.panels.length) return;

      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);

      this.root.dataset.afContentSelectorReady = 'true';
      this.root.setAttribute('data-af-content-selector-enhanced', '');
      this.root.style.setProperty('--af-content-selector-count', this.tabs.length);

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.onClick);
        tab.addEventListener('keydown', this.onKeydown);
      });

      this.activate(0, false);
    }

    destroy() {
      this.tabs.forEach((tab) => {
        tab.removeEventListener('click', this.onClick);
        tab.removeEventListener('keydown', this.onKeydown);
      });
      delete this.root.dataset.afContentSelectorReady;
      this.root.removeAttribute('data-af-content-selector-enhanced');
    }

    onClick(event) {
      const index = this.tabs.indexOf(event.currentTarget);
      if (index >= 0) this.activate(index, false);
    }

    onKeydown(event) {
      const index = this.tabs.indexOf(event.currentTarget);
      if (index < 0) return;

      let next = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = this.tabs.length - 1;
      if (next === null) return;

      event.preventDefault();
      this.activate(next, true);
    }

    activate(index, focus) {
      this.tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });

      this.panels.forEach((panel, panelIndex) => {
        const active = panelIndex === index;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });

      if (focus) this.tabs[index]?.focus({ preventScroll: true });
    }
  }

  const instances = new WeakMap();

  const init = (scope = document) => {
    const roots = scope.matches?.(ROOT) ? [scope] : Array.from(scope.querySelectorAll?.(ROOT) || []);
    roots.forEach((root) => {
      if (!instances.has(root)) instances.set(root, new AFContentSelector(root));
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
